(() => {
  const chat = document.querySelector('[data-support-chat]');
  if (!chat) return;
  const launcher = chat.querySelector('[data-chat-open]');
  const panel = chat.querySelector('[data-chat-panel]');
  const closeButton = chat.querySelector('[data-chat-close]');
  const form = chat.querySelector('[data-chat-form]');
  let previousFocus;

  const syncPanelPosition = () => {
    if (panel.hidden) return;
    const gap = 10;
    const margin = 14;
    const launcherRect = launcher.getBoundingClientRect();
    const panelRect = panel.getBoundingClientRect();
    const width = panelRect.width;
    const height = panelRect.height;
    const maxLeft = Math.max(margin, innerWidth - width - margin);
    const left = Math.min(maxLeft, Math.max(margin, launcherRect.right - width));
    const above = launcherRect.top - height - gap;
    const maxTop = Math.max(margin, innerHeight - height - margin);
    const top = Math.min(
      maxTop,
      Math.max(margin, above >= margin ? above : launcherRect.bottom + gap)
    );
    Object.assign(panel.style, { left: `${left}px`, top: `${top}px`, right: 'auto', bottom: 'auto' });
  };
  const setOpen = open => {
    if (open) previousFocus = document.activeElement;
    panel.hidden = !open;
    launcher.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('support-chat-open', open);
    if (open) {
      syncPanelPosition();
      closeButton.focus();
    } else previousFocus?.focus?.();
  };
  window.addEventListener('resize', syncPanelPosition, { passive: true });
  launcher.addEventListener('click', () => setOpen(panel.hidden));
  closeButton.addEventListener('click', () => setOpen(false));
  panel.addEventListener('keydown', event => { if (event.key === 'Escape') setOpen(false); });
  form.addEventListener('submit', event => {
    event.preventDefault();
    const message = new FormData(form).get('message');
    window.location.href = `mailto:${form.dataset.supportEmail}?subject=LeNovember support request&body=${encodeURIComponent(message)}`;
  });
})();
